module.exports = __webpack_public_path__ + "static/img/legales_bg.11bacdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/legales_bg.png
// module id = tZUO
// module chunks = 0